import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { useHistory } from 'react-router-dom';
import Container from 'components/v2/container';
import CargomaticCard from 'components/v2/card';
import Breadcrumbs from 'components/v2/Breadcrumbs';
import { Button } from 'react-bootstrap';
import TextArea from 'components/v2/forms/TextArea';
import Alert from 'components/ui/Alert';
import { showToast } from 'stores/ToastStore';
import { submitEmptyNotifyContainersRequest, getShipperWarehouseRelation, } from 'utils/WarehouseUserAPIUtils';
import { sluggify } from 'utils/localization/utils';
import SessionStore from 'stores/SessionStore';
import LoadingCircle from 'components/ui/LoadingCircle';
const pageTestKey = 'warehouse-portal-empty-notify';
export default function EmptyNotify() {
    const { t } = useTranslation();
    const history = useHistory();
    const [containerStr, setContainerStr] = useState('');
    const [containerErrors, setContainerErrors] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const getShipperWarehouseRelationStatus = async () => {
        try {
            setIsLoading(true);
            const { entity: { data }, } = await getShipperWarehouseRelation(true, true);
            const status = (data === null || data === void 0 ? void 0 : data.length) > 0;
            SessionStore.setShipperWarehouseRelationStatus(status);
        }
        catch (error) {
            SessionStore.setShipperWarehouseRelationStatus(false);
            console.error(error);
        }
        finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        if (localStorage.getItem('shipperWarehouseRelationStatus') === null) {
            getShipperWarehouseRelationStatus();
        }
    }, []);
    useEffect(() => {
        const invalidContainer = containerStr === null || containerStr === void 0 ? void 0 : containerStr.split(/[\n,]+/).map((item) => item.trim()).filter((item) => !item || (item === null || item === void 0 ? void 0 : item.length) < 10);
        setContainerErrors(invalidContainer === null || invalidContainer === void 0 ? void 0 : invalidContainer.join(', '));
    }, [containerStr]);
    const breadcrumbs = {
        pages: [
            {
                name: t('EMPTY_NOTIFY_PORTAL'),
                href: `/`,
                current: true,
            },
        ],
    };
    const handleSaveContainers = async () => {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            const containers = containerStr
                .split(/[\n,]+/)
                .map((item) => item.trim())
                .filter((item) => item);
            const response = await submitEmptyNotifyContainersRequest({ containers });
            if (((_a = response.entity) === null || _a === void 0 ? void 0 : _a.success) && ((_c = (_b = response.entity) === null || _b === void 0 ? void 0 : _b.result) === null || _c === void 0 ? void 0 : _c.items)) {
                const reportId = (_f = (_e = (_d = response.entity) === null || _d === void 0 ? void 0 : _d.result) === null || _e === void 0 ? void 0 : _e.items[0]) === null || _f === void 0 ? void 0 : _f._id;
                showToast(t('EMPTY_NOTIFY'), t('EMPTY_NOTIFY_SAVE_SUCCESS'), 'success');
                if (reportId) {
                    history.push(`/warehouse/empty-notify-requests/${reportId}`);
                }
                else {
                    showToast('', t('REPORT_ID_NOT_FOUND'), 'error');
                }
            }
        }
        catch (error) {
            const errroMsg = ((_g = error === null || error === void 0 ? void 0 : error.entity) === null || _g === void 0 ? void 0 : _g.error) || 'SOMETHING_WENT_WRONG';
            showToast(t('EMPTY_NOTIFY'), t('EMPTY_NOTIFY_SAVE_ERROR', { error: t(sluggify(errroMsg)) }), 'error');
        }
    };
    const status = SessionStore.getShipperWarehouseRelationStatus();
    const isShipperRelationEnabled = status === 'true';
    if (isLoading) {
        return (React.createElement(Container, { className: "lg:mt-0 mt-4" },
            React.createElement(Breadcrumbs, { className: "mt-4", breadcrumbs: breadcrumbs }),
            React.createElement(LoadingCircle, { text: t('LOADING'), className: "mt-4" })));
    }
    return (React.createElement(Container, { className: "lg:mt-0 mt-4" },
        React.createElement(Breadcrumbs, { className: "mt-4", breadcrumbs: breadcrumbs }),
        !isShipperRelationEnabled && (React.createElement(Alert, { type: "warning" }, t('USER_WAREHOUSE_MAPPING_WARNING'))),
        React.createElement("div", { "data-tesid": `${pageTestKey}-page`, className: "lg:grid lg:grid-cols-1 lg:gap-6 mt-4" },
            React.createElement(CargomaticCard, { header: () => (React.createElement("div", { className: "flex items-center justify-between" },
                    React.createElement("h3", { className: "my-0" }, t('EMPTY_NOTIFY')))), footer: () => (React.createElement("div", { "data-testid": `${pageTestKey}-footer`, className: "form-actions gap-2" },
                    React.createElement(Button, { bsClass: `btn btn-default ${!isShipperRelationEnabled ? 'cursor-not-allowed' : ''}`, onClick: () => setContainerStr(''), "data-testid": `${pageTestKey}-cancel-button`, disabled: !isShipperRelationEnabled }, titleize(t('CLEAR'))),
                    React.createElement(Button, { bsStyle: "primary", "data-testid": `${pageTestKey}-save-button`, onClick: () => handleSaveContainers(), disabled: !(containerStr === null || containerStr === void 0 ? void 0 : containerStr.length) || (containerErrors === null || containerErrors === void 0 ? void 0 : containerErrors.length) }, titleize(t('SAVE'))))), showFooter: true, grayFooter: true },
                React.createElement("div", { className: "text-sm font-bold px-0.5" }, t('CONTAINER_NUMBERS')),
                React.createElement("div", { className: "text-sm font-sans text-gray-500 p-0.5" }, t('CONTAINER_NUMBERS_NOTES')),
                React.createElement(TextArea, { rows: 8, value: containerStr, placeholder: t('COMMA_OR_LINE_SEPARATED_LIST'), onChange: (value) => setContainerStr(value), disabled: !isShipperRelationEnabled }),
                containerErrors && (React.createElement("div", { className: "mt-4" },
                    React.createElement(Alert, { type: "error" },
                        t('VALIDATE_CONTAINERS_ID'),
                        ": ",
                        containerErrors)))))));
}
